import { useTranslation } from 'react-i18next';

import SecondaryPageLayout from '@/Layout/SecondaryPageLayout';
import usePrefilledIdentifier from '@/hooks/use-prefilled-identifier';
import { useForgotPasswordSettings } from '@/hooks/use-sie';
import { useStudentLogin } from '@/hooks/use-student-login';
import { identifierInputDescriptionMap } from '@/utils/form';

import ErrorPage from '../ErrorPage';

import ForgotPasswordForm from './ForgotPasswordForm';

const ForgotPassword = () => {
  const { isForgotPasswordEnabled, enabledMethodSet } = useForgotPasswordSettings();
  const { isStudentLookupEnabled } = useStudentLogin();
  const { t } = useTranslation();
  const enabledMethods = [...enabledMethodSet];
  const { value: prefilledValue } = usePrefilledIdentifier({
    enabledIdentifiers: enabledMethods,
    isForgotPassword: true,
  });

  // Student mode resolves the reset channel from the entered student/registration number,
  // so it does not depend on the tenant's email/phone forgot-password methods being enabled.
  if (!isForgotPasswordEnabled && !isStudentLookupEnabled) {
    return <ErrorPage />;
  }

  return (
    <SecondaryPageLayout
      title="description.reset_password"
      description="description.reset_password_description"
      descriptionProps={{
        types: enabledMethods.map((method) => t(identifierInputDescriptionMap[method])),
      }}
    >
      <ForgotPasswordForm autoFocus defaultValue={prefilledValue} enabledTypes={enabledMethods} />
    </SecondaryPageLayout>
  );
};

export default ForgotPassword;
